import React from "react";
import { Text } from "../../design-system/Text";

const Maintainance = () => {
  return (
    <div className="flex-1 grid place-content-center justify-center items-center h-[90vh]">
      <Text as={"h1"} className="xs:text-2xl 5xl:text-3xl 5xl:font-normal">
        Screen Under Development
      </Text>
    </div>
  );
};

export default Maintainance;
